import React from 'react';
import type { IconProps } from '@mc/design-system';
/* istanbul ignore file */
// Two elements required: merging these styles onto one element makes currentColor in background resolve against its own color, rendering the glyph invisible.
const FILLED_STYLE: React.CSSProperties = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '50%',
  background: 'var(--cert-icon-circle, currentColor)'
};
const FILLED_INNER: React.CSSProperties = {
  display: 'flex',
  width: '64%',
  height: '64%',
  color: 'var(--cert-icon-fg, var(--c-beige-100, #FEFAF2))'
};
function IconSettings({
  srText,
  size = 'md',
  className = '',
  filled,
  ...props
}: IconProps & {
  filled?: boolean;
}) {
  const sizeClassName = `mc-icon mc-icon--${size} ${className}`;
  const newClassName = filled ? '' : sizeClassName;
  const svg = <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="-5.6 -5.6 31.2 31.2" aria-hidden="true" role="img" className={newClassName} {...props}><path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.667} d="M10 12.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5" /><path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.667} d="M16.17 12.503a1.375 1.375 0 0 0 .274 1.516l.05.05a1.667 1.667 0 1 1-2.358 2.359l-.05-.05a1.375 1.375 0 0 0-1.517-.275 1.38 1.38 0 0 0-.833 1.258v.142a1.667 1.667 0 0 1-3.333 0v-.075a1.375 1.375 0 0 0-.9-1.259 1.375 1.375 0 0 0-1.517.275l-.05.05a1.666 1.666 0 0 1-2.72-1.817c.084-.202.207-.386.362-.541l.05-.05a1.375 1.375 0 0 0 .275-1.517 1.38 1.38 0 0 0-1.259-.833h-.141a1.667 1.667 0 0 1 0-3.333h.075a1.375 1.375 0 0 0 1.258-.9 1.375 1.375 0 0 0-.275-1.517l-.05-.05a1.667 1.667 0 1 1 2.358-2.358l.05.05a1.375 1.375 0 0 0 1.517.275h.067a1.38 1.38 0 0 0 .833-1.259v-.141a1.667 1.667 0 1 1 3.333 0v.075a1.37 1.37 0 0 0 .834 1.258 1.375 1.375 0 0 0 1.516-.275l.05-.05a1.667 1.667 0 1 1 2.359 2.358l-.05.05a1.375 1.375 0 0 0-.275 1.517v.067a1.38 1.38 0 0 0 1.258.833h.142a1.667 1.667 0 1 1 0 3.333h-.075a1.37 1.37 0 0 0-1.259.834" /></svg>;
  if (filled) {
    return <>{!!srText && <span className='mc-sr-only'>{srText}</span>}<span className={sizeClassName} style={FILLED_STYLE}><span style={FILLED_INNER}>{React.cloneElement(svg, {
            style: {
              width: '100%',
              height: '100%',
              ...props.style
            }
          })}</span></span></>;
  }
  return <>{!!srText && <span className='mc-sr-only'>{srText}</span>}{svg}</>;
}
export default IconSettings;